import { render } from "./DataLogPerangkatAll.vue?vue&type=template&id=7a0c2c2e"
import script from "./DataLogPerangkatAll.vue?vue&type=script&lang=js"
export * from "./DataLogPerangkatAll.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vitechasia/Documents/Kantor/project_nuxt/vuess/vtadesk-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__